<template>
  <v-snackbar :timeout="10000" auto-heigth multi-line v-model="errorMes" color="primary" absolute right top class="mt-15">
    <v-layout align-center pr-4>
      <v-icon class="pr-3" dark large>mdi-alert</v-icon>
      <v-layout column>
        <div>
          <strong>{{ $t("crud.problem") }}</strong>
        </div>
        <div>{{ $t("crud.error") }}</div>
      </v-layout>
    </v-layout>
  </v-snackbar>
</template>

<script>


export default {
  name: "error", methods: {},

  data() {
    return {
      errorMes: false,
    }
  },

  created () {
    // eslint-disable-next-line no-undef
    EventBus.$on('error', (data) =>{
      this.errorMes = data;
    })

  }
}
</script>

<style scoped></style>
